<template>
  <transition name="slide-fade">
    <div class="audio-line">
      <div v-for="index in 16" :key="index" class="line audioAn" />
    </div>
  </transition>
</template>

<script>
export default {
  name: 'AudioHint'
}
</script>

<style scoped lang="scss">
.slide-fade-enter, .slide-fade-leave-to {
  transform: translateY(20px);
  opacity: 0;
}
.audio-line {
  transition: all 0.8s;
  z-index: 9999;
  background: url(../../assets/audio/audio-background.png) no-repeat;
  background-size: 190px 80px;
  left: 24%;
  top: 50%;
  width: 190px;
  height: 80px;
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  .line {
    margin-left: 3px;
    width: 1px;
    height: 10px;
    background-color: #000000;
  }
  @keyframes audioAn {
    from{
      height: 12px;
    }
    to{
      height: 5px;
    }
  }
  .audioAn{
    animation-name: audioAn;
    animation-duration: 500ms;
    animation-iteration-count: infinite;
    animation-direction:alternate;
  }
  @for $i from 1 through 16{
    .audioAn:nth-child(#{$i}){
      animation-delay: $i*200ms;
    }
    .audioAn:nth-child(#{$i + 1}){
      animation-delay: $i*300ms;
    }
  }
}
</style>
